import moment from 'moment';
import { QueryKey, UseQueryOptions } from 'react-query';
import { descending } from '../../../../utils/array-utils';
import { useAuthQuery } from '../../../../utils/queryUtils';
import { Title } from '../../titles/types/title';
import { bookmarksQuery, continueWatchingTitlesQuery } from './queries';
import { Bookmark } from './types';

export function useBookmarks<T = Bookmark[]>(options?: UseQueryOptions<Bookmark[], unknown, T, QueryKey>) {
  return useAuthQuery(bookmarksQuery(options), ['user', 'home']);
}

export function useMostRecentBookmark(
  masterId: string,
  options?: Omit<UseQueryOptions<Bookmark[], unknown, Bookmark, QueryKey>, 'select'>,
) {
  return useBookmarks({
    ...options,
    select: (data) => {
      const filetedBookmarks = data.filter((b) => b.masterId === masterId);
      const sortedBookmarks = filetedBookmarks.sort(descending((b) => moment(b.dateTime).unix()));
      return sortedBookmarks[0];
    },
  });
}

export function useContinueWatchingTitles<T = Title[]>(options?: UseQueryOptions<Title[], unknown, T, QueryKey>) {
  return useAuthQuery(continueWatchingTitlesQuery(options), ['user', 'home']);
}
